import http from "./http";

// ------- bulk vehicle data -----------
function verify_vehicle_data(data) {
  return http.post(`verify_vehicleData`, data);
}

function add_bulk_vehicle_data(data) {
  return http.post(`save_vehicleData`, data);
}

function list_bulk_vehicle_data(data) {
  return http.post(`vehicleImei_List`, data);
}

function delete_bulk_vehicle_data(data) {
  return http.post(`deleteVehicle_List`, data);
}

const BulkImeiService = {
  verify_vehicle_data,
  add_bulk_vehicle_data,
  list_bulk_vehicle_data,
  delete_bulk_vehicle_data,
};

export default BulkImeiService;
